import { render } from "./sticky-feedback.vue?vue&type=template&id=29831b64"
import script from "./sticky-feedback.vue?vue&type=script&lang=js"
export * from "./sticky-feedback.vue?vue&type=script&lang=js"

import "./sticky-feedback.vue?vue&type=style&index=0&id=29831b64&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__